export function openURL(uri: string): void {
  window.open(uri);
}
